var React = require('react/addons');
var cx = require('classnames');

var ReactForms = require('react-forms');
var PropTypes = ReactForms.PropTypes;
var Message = ReactForms.Message;
var FocusStore = ReactForms.FocusStore;
var Hint = require('react-forms/lib/Hint');


var BooleanField = React.createClass({

  mixins: [FocusStore.FocusableMixin],

  propTypes: {
    label: React.PropTypes.string,
    hint: React.PropTypes.string,
    value: PropTypes.Value,
    input: React.PropTypes.oneOfType,
    noLabel: React.PropTypes.bool
  },

  render() {
    var {value, hint, label, className, ...props} = this.props;
    var {node, validation, isDirty, externalValidation} = value;
    var isInvalid = isDirty && (validation.isFailure || externalValidation.isFailure);

    var classNames = cx({
      'ofs-Form__Field': true,
      'ofs-Form__Field--inline': true,
      'ofs-Form__Field--invalid': isInvalid,
      'ofs-Form__Field--dirty': isDirty
    });

    var id = this._rootNodeID;

    return (
      <div {...props} className={cx(classNames, className)} value={undefined}>
        <label className="ofs-Form__Label ofs-Form__Label--no-bold">
          <input
            type="checkbox"
            className="ofs-Input ofs-Input--checkbox"
            ref="input"
            id={id}
            checked={value.value}
            onBlur={this.onBlur}
            onChange={this.onChange} />
            <div className="ofs-Input__OptionLabel">{label || node.props.get('label')}</div>
        </label>
        {hint || node.props.get('hint') ? <Hint hint={hint || node.props.get('hint')} /> : null}
        {validation.isFailure && isDirty &&
          <Message>{validation.error}</Message>}
        {externalValidation.isFailure &&
          <Message>{externalValidation.error}</Message>}
      </div>
    );
  },

  focus() {
    this.refs.input.focus();
  },

  onChange(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }

    var serialized = getValueFromEvent(e);
    this.props.value.setSerialized(serialized);
  },

  onBlur() {
    var {value} = this.props;
    if (!value.isDirty) {
      value.makeDirty();
    }
  }
});

/**
 * Extract value from event
 *
 * We support both React.DOM 'change' events and custom change events
 * emitted from custom components.
 *
 * @param {Event} e
 * @returns {Any}
 */
function getValueFromEvent(e) {
  return e && e.target && e.target.checked !== undefined ?
    e.target.checked : e;
}

module.exports = BooleanField;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/components/boolean-field.jsx
 **/